import React from 'react';
import { Link } from 'react-router-dom';
import { useOptionalMasterEvent } from '../../context/MasterEventContext';
import './TeamsPanel.css';

export default function TeamTag({ userId, user }) {
  const event = useOptionalMasterEvent();
  if (!event || !Array.isArray(event.teams)) return null;
  const ids = [userId, user?.id, user?.userId, user?.cognitoId].filter(Boolean);
  const team = event.teams.find(t => t && !t.activityId && Array.isArray(t.members) && t.members.some(m => ids.includes(m)));
  if (!team) return null;
  const selection = (Array.isArray(event.activities) ? event.activities : []).find(a => a?.type === 'teamselection' && a.status !== 'draft');
  const style = { color: team.color };
  return selection && event.masterEvent?.id ? <Link className="team-tag" style={style} to={`/me/${event.masterEvent.id}/activity/${selection.id}`}>{team.name}</Link>
    : <span className="team-tag" style={style}>{team.name}</span>;
}
